import '@capacitor/app'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import './registerServiceWorker';

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

import { defineCustomElements } from '@ionic/pwa-elements/loader';

/* Theme variables */
import './theme/variables.css';

/* Internationalitaion */
import store from './store'
import { db } from '@/utilities';

const app = createApp(App)
  .use(store)
  .use(IonicVue)
  .use(router);


router.isReady().then(async () => {
  await db.enablePersistence({ experimentalForceOwningTab: true })
  console.log('init - bind the auth user')
  await store.dispatch('auth/initializeFirebaseAuth')
  await store.dispatch('device/initialize')
  console.log('init - start the application')
  app.mount('#app');

  // Call the element loader after the platform has been bootstrapped
  defineCustomElements(window);
});